
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeYunqi extends Vue {
  @Prop()
  private message: any;
}
